<template>
  <div class="common-questions">
    <div class="banner">
      <img src="@/assets/home/img_sjgl_cjwt_n@2x.png" alt="" class="bg-img">
    </div>

    <div class="search-container">
      <div class="search-box">
        <i class="el-icon-search search-icon"></i>
        <input type="text" v-model="keyword" placeholder="搜索关键词" class="search-input" @keyup.enter="handleSearch">
        <button class="search-btn" @click="handleSearch">搜索</button>
      </div>
    </div>

    <div class="question-list">
      <div v-for="(item, index) in questionList" :key="index" class="question-item"
        :class="{ expanded: item.expanded }">
        <div class="question-header" @click="toggleExpand(index)">
          <div class="icon-wrapper">
            <img src="@/assets/home/icon_wt_jh_n@2x.png" class="expand-icon" :class="{ 'is-expanded': item.expanded }"
              alt="">
          </div>
          <span class="question-title">{{ item.title }}</span>
        </div>
        <div class="question-content" ref="content" :style="{ maxHeight: item.expanded ? '200px' : '0' }">
          <div class="content-inner">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>

    <div class="pagination-container">
      <Pagination
        type="allColor"
        :pageNo="pageIndex"
        :pageSize="pageSize"
        :total="total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import { FAQList } from "@/api/channel";
import Pagination from '@/components/pagination.vue';

export default {
  name: 'CommonQuestions',
  components: {
    Pagination
  },
  data() {
    return {
      keyword: '',
      questionList: [],  // 存储展示的问题数据
      pageIndex: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.getFAQList();
  },
  methods: {
    async getFAQList() {
      try {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        };
        if (this.keyword.trim()) {
          params.Title = this.keyword.trim();
        }
        const res = await FAQList(params);
        if (res && res.code === 0 && Array.isArray(res.data.data)) {
          this.questionList = res.data.data.map(item => ({
            title: item.Title,
            content: item.InfoContent,
            expanded: false
          }));
          this.total = res.data.Count || 0;
          // 默认展开第一条（如果需要）
          // if (this.questionList.length > 0) {
          //   this.questionList[0].expanded = true;
          // }
        } else {
          this.questionList = [];
          this.total = 0;
        }
      } catch (error) {
        console.error("获取常见问题失败", error);
        this.questionList = [];
        this.total = 0;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getFAQList();
    },
    toggleExpand(index) {
      this.questionList[index].expanded = !this.questionList[index].expanded;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getFAQList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getFAQList();
    }
  },
  watch: {
    keyword(val) {
      if (!val) {
        this.pageIndex = 1;
        this.getFAQList();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.common-questions {
  width: 780px;
  height: 100%;
  background: #FFFFFF;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .banner {
    position: relative;
    width: 100%;
    height: 180px;
    margin-bottom: 20px;
    border-radius: 8px;
    overflow: hidden;

    .bg-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .banner-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #FFFFFF;

      .title {
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 10px;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
      }

      .subtitle {
        display: inline-block;
        padding: 6px 20px;
        border: 1px solid rgba(255, 255, 255, 0.6);
        border-radius: 20px;
        font-size: 14px;
        background: rgba(255, 255, 255, 0.1);
      }
    }
  }

  .search-container {
    padding: 0 10px;
    margin-bottom: 20px;

    .search-box {
      display: flex;
      align-items: center;
      border: 1px solid #EAECEF;
      border-radius: 24px;
      padding: 5px 5px 5px 20px;
      background: #FFF;
      transition: all 0.3s;

      &:focus-within {
        border-color: #E71D43;
        box-shadow: 0 0 0 2px rgba(231, 29, 67, 0.1);
      }

      .search-icon {
        color: #999;
        font-size: 16px;
        margin-right: 10px;
      }

      .search-input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 14px;
        color: #333;

        &::placeholder {
          color: #CCC;
        }
      }

      .search-btn {
        background: #E71D43;
        color: #FFF;
        border: none;
        border-radius: 20px;
        padding: 8px 24px;
        font-size: 14px;
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: #D91238;
        }
      }
    }
  }

  .question-list {
    padding: 0 10px;
    flex: 1;
    max-height: 690px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }

    .question-item {
      margin-bottom: 14px;
      border-radius: 4px;
      overflow: hidden;

      &.expanded {
        background: transparent;
        border-radius: 0;
      }

      .question-header {
        display: flex;
        align-items: center;
        padding: 15px 10px;
        cursor: pointer;
        transition: background 0.2s;
        background: #F5F7FA;
        box-shadow: inset 0px -1px 0px 0px #EBEDF0, inset 0px 1px 0px 0px #EBEDF0;

        // &:hover {
        //   background: rgba(0, 0, 0, 0.02);
        // }

        .icon-wrapper {
          margin-right: 15px;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .expand-icon {
          width: 18px;
          height: 18px;
          transition: transform 0.3s;

          &.is-expanded {
            transform: rotate(45deg); // 假设加号旋转45度变成叉号，或者如果是减号需要其他处理
            // 如果设计是变成减号，可能需要换图片或者CSS处理
            // 这里假设 icon_wt_jh_n@2x.png 是一个圆圈加号
          }
        }

        .question-title {
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }
      }

      .question-content {
        transition: max-height 0.3s ease-in-out;
        overflow: hidden;

        .content-inner {
          padding: 15px;
          margin: 10px 0px;
          font-size: 14px;
          color: #666;
          line-height: 1.6;
          text-align: justify;
          background: #FAEDED;
          border-radius: 10px;
        }
      }
    }
  }

  .more-questions {
    text-align: center;
    padding: 20px 0;
    color: #666;
    font-size: 14px;
    cursor: pointer;

    i {
      margin-left: 5px;
    }

    &:hover {
      color: #E71D43;
    }
  }

  .pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
  }
}
</style>
